<template>
<BlockConfig title="Tabella misure"
    :valid="valid"
    @handleSave="handleSave"
    @restore="restore">
    <v-form v-model="valid">
        <div class="d-flex my-2">
            <v-text-field dense outlined
                label="nome prova*"
                :rules="[rules.mandatory]" 
                v-model="config_data.title"
            ></v-text-field>
            <v-text-field dense outlined
                v-model="config_data.min_readings"
                class="ml-2"
                :rules="[rules.mandatory]" 
                label="misure minime*"
            />
        </div>
        <div class="d-flex my-2">
            <v-text-field dense outlined
                label="traduzione inglese"
                v-model="config_data.translation"
            ></v-text-field>
        </div>
        <div>
            <v-label>etichette tabella<span class="caption"> - (ordine fisso)</span></v-label>
            <div class="d-flex mt-2">
                <v-text-field dense outlined label="valore nominale" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.nom"></v-text-field>
                <v-text-field dense outlined label="valore di zero" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.zero"></v-text-field>
                <v-text-field dense outlined label="indicazione" placeholder="" :rules="[rules.mandatory]" v-model="config_data.headers.reading"></v-text-field>
                <v-text-field dense outlined label="errore" placeholder=""  required :rules="[rules.mandatory]" v-model="config_data.headers.difference"></v-text-field>
                <v-text-field dense outlined label="errore formattato" placeholder=""  required :rules="[rules.mandatory]" v-model="config_data.headers.toleranceError"></v-text-field>
            </div>
        </div>
    </v-form>
</BlockConfig>
</template>
<script>
import {ConfigMixin} from '../../../utils/configMixin_new'
import BlockConfig from '../../../components/utils/BlockConfig'

export default {
    components: {BlockConfig},
    mixins: [ConfigMixin],
    // props: ["data"],
    data() {
        return {
            // valid: false,
            // rules: f_rules,
            o_data: {
                title: this.data.block.label,
                translation: "",
                min_readings: 5,
                headers: {
                   'count': 'n',
                   'nom': 'val. conv.', 'zero': 'zero', 'reading': 'lettura', 'difference': 'errore', 'toleranceError': 'errore formattato' 
                }
            },
        }
    },
    
}
</script>    